import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const BudgetPeriods = lazy(() => import('./BudgetPeriods'));
const Budgets = lazy(() => import('./Budgets'));
const BudgetAllocations = lazy(() => import('./BudgetAllocations'));
const BudgetMonitoring = lazy(() => import('./BudgetMonitoring'));

export const budgetingRoutes = (
  <React.Fragment key="budgeting">
    <Route element={<ProtectedRoute permission="finance.budget.view" />}>
      <Route path="/budgeting/periods" element={<BudgetPeriods />} />
      <Route path="/budgeting/budgets" element={<Budgets />} />
      <Route path="/budgeting/allocations" element={<BudgetAllocations />} />
      <Route path="/budgeting/monitoring" element={<BudgetMonitoring />} />
    </Route>
  </React.Fragment>
);
